/* Barre d'achat collante des pages (bloc nky-barre).
   Sur le site : la barre est déplacée sous <body> (un ancêtre transformé par l'animation d'apparition de Dawn
   casserait position: fixed), puis montrée après « data-seuil » px de défilement et cachée quand le pied de
   page arrive (il porte déjà ses propres liens). Dans l'éditeur : rien ne bouge, la barre reste un aperçu. */
(function () {
  function brancher(barre) {
    if (barre.dataset.nkyPret || barre.classList.contains('nky-barre--editeur')) return;
    barre.dataset.nkyPret = '1';
    (document.body || document.documentElement).appendChild(barre);
    document.documentElement.classList.add('nky-avec-barre');
    var seuil = parseInt(barre.dataset.seuil || '500', 10);
    var pied = document.querySelector('footer, .footer, #shopify-section-footer');
    var piedVu = false;
    if (pied && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) { piedVu = e[0].isIntersecting; maj(); }).observe(pied);
    }
    var attente = false;
    function maj() {
      attente = false;
      var montrer = window.scrollY > seuil && !piedVu;
      barre.classList.toggle('vu', montrer);
      barre.inert = !montrer;
    }
    window.addEventListener('scroll', function () {
      if (!attente) { attente = true; requestAnimationFrame(maj); }
    }, { passive: true });
    maj();
  }
  function tout() { document.querySelectorAll('[data-nky-barre]').forEach(brancher); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', tout); else tout();
})();
